/* eslint-disable @typescript-eslint/no-explicit-any */

export const urlToObject = async (url: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], 'image.jpg', { type: blob.type });
  return file;
};

export async function testWebShare({
  text,
  files: filesUrl
}: {
  text: string;
  files: string[];
}) {
  console.debug('testWebShare', text, filesUrl);
  let files;
  const newNavigator = window.navigator as any;
  // Test compatibility
  if (newNavigator.share === undefined) {
    console.debug('Unsupported share feature');
    return;
  }

  // Handle file urls
  if (filesUrl && filesUrl.length > 0) {
    const filesGetter = filesUrl.map((file) => urlToObject(file));
    const newFiles = await Promise.all(filesGetter);

    if (
      !newNavigator.canShare ||
      !newNavigator.canShare({ files: newFiles } as any)
    ) {
      console.debug('Unsupported share feature');
      return;
    }

    files = newFiles;
  }

  // Share content
  try {
    await newNavigator.share({ text, files } as any);
  } catch (error) {
    console.debug(`Error sharing: ${error}`);
  }
}
